// PMax Final URL Expansion — Account Structure section, deterministic check.
// Per-campaign on/off, opted-out campaigns first.

import type { EvidenceProps } from './registry';

interface CampaignRow {
  id?: string;
  name: string;
  expansionOn: boolean;
}

interface FinalUrlShape {
  totalCampaigns: number;
  expansionOnCount: number;
  expansionOffCount: number;
  campaigns: CampaignRow[];
}

export const PmaxFinalUrlExpansionEvidence = ({ evidence }: EvidenceProps) => {
  const e = evidence as unknown as FinalUrlShape;

  return (
    <div className='evidence'>
      <section className='evidence__section'>
        <h4 className='evidence__section-title'>
          Final URL Expansion
          <span className='evidence__section-tag evidence__section-tag--context'>
            {e.totalCampaigns} PMax campaigns
          </span>
        </h4>
        <div className='audience-coverage'>
          <div className='audience-coverage__cell'>
            <div className='audience-coverage__num'>{e.expansionOnCount.toLocaleString()}</div>
            <div className='audience-coverage__lbl'>Expansion on</div>
          </div>
          <div className='audience-coverage__cell'>
            <div className='audience-coverage__num'>{e.expansionOffCount.toLocaleString()}</div>
            <div className='audience-coverage__lbl'>Opted out</div>
          </div>
        </div>
      </section>

      <section className='evidence__section'>
        <h4 className='evidence__section-title'>Per-campaign setting</h4>
        <table className='evidence__table evidence__table--pmax-final-url'>
          <thead>
            <tr>
              <th>Campaign</th>
              <th>Final URL Expansion</th>
            </tr>
          </thead>
          <tbody>
            {e.campaigns.map(c => (
              <tr key={c.id ?? c.name}>
                <td>{c.name}</td>
                <td>
                  <span
                    className={`evidence__strength ${
                      c.expansionOn ? 'evidence__strength--good' : 'evidence__strength--average'
                    }`}
                  >
                    {c.expansionOn ? 'On' : 'Opted out'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <p className='evidence__footnote'>
        Final URL Expansion lets Performance Max route traffic to additional relevant landing pages
        it discovers, capturing incremental converting queries. Tinuiti's default lean is on — but
        off is a legitimate choice for strict landing-page control, limited assortment,
        thin/out-of-stock pages, or when declining Text Customization (which Final URL Expansion
        auto-enables). Opted-out campaigns are worth confirming as intentional.
      </p>
    </div>
  );
};
